@if (!config.hide) {
  <div [ngClass]="config.class">
    <label class="toggle-label">{{ config.label }}</label>
    <div class="toggle-button" [formGroup]="group">
      <label class="switch">
        @if (config.changeEvent) {
          <input  class="switch-input" type="checkbox" [formControlName]="config.name" (change)="toggleChange($event)"/>
        }
        @if (!config.changeEvent) {
          <input  class="switch-input" type="checkbox" [formControlName]="config.name"/>
        }
        <span class="switch-label {{config.name}}" data-on="Yes" data-off="No"></span>
        <span class="switch-handle" id="{{config.id}}"></span>
      </label>
    </div>
  </div>
}
